import React from 'react';
import { memo } from 'react';
import { Modal, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CarBrandCharacteristics from '../../../CarBrandCharacteristics/CarBrandCharacteristics';
import { ModalCharacteristicsProps } from '../../interfaces';
import styles from './modalCharacteristics.module.scss';

const ModalCharacteristics: React.FC<ModalCharacteristicsProps> = ({
    open,
    onClose,
    selectedVehicleId,
    publication
}) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    p: 3,
                    width: '70%',
                    maxWidth: 500,
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    outline: 'none',
                }}
            >
                <Box
                    sx={{
                        color: '#1D1B2080',
                        position: 'absolute',
                        top: 20,
                        right: 20,
                        cursor: 'pointer',
                        zIndex: 10,
                    }}
                    onClick={onClose}
                >
                    <CloseIcon />
                </Box>
                <h2 className={styles.modalTitle}>Características adicionales</h2>
                <div className={styles.modalContent}>
                    {(() => {
                        if (!publication) {
                            return <p>No se encontró la publicación</p>;
                        }

                        const selectedVehicle = selectedVehicleId && publication.vehicles?.find((v: any) => v._id === selectedVehicleId);
                        
                        if (selectedVehicle?.additional_characters?.length > 0) {
                            return selectedVehicle.additional_characters.map((category: any) => (
                                <div key={category.code} className={styles.categoryBlock}>
                                    <p className={styles.categoryTitle}>{category.name}</p>
                                    {category.value
                                        ?.filter((item: any) => item.value === true)
                                        ?.map((item: any, index: number) => (
                                            <div
                                                key={item.code}
                                                className={`${styles.characteristicRow} ${index % 2 !== 0 ? styles.rowGray : ''}`}
                                            >
                                                <span className={styles.characteristicName}>{item.name}</span>
                                                <span className={styles.characteristicValue}>Sí</span>
                                            </div>
                                        ))}
                                </div>
                            ));
                        } 
                        else if (publication?.vehicle_data?.additional_characters?.length > 0) {
                            return publication.vehicle_data.additional_characters.map((category: any) => (
                                <div key={category.code} className={styles.categoryBlock}>
                                    <p className={styles.categoryTitle}>{category.name}</p>
                                    {category.value
                                        ?.filter((item: any) => item.value === true)
                                        ?.map((item: any, index: number) => (
                                            <div
                                                key={item.code}
                                                className={`${styles.characteristicRow} ${index % 2 !== 0 ? styles.rowGray : ''}`}
                                            >
                                                <span className={styles.characteristicName}>{item.name}</span>
                                                <span className={styles.characteristicValue}>Sí</span>
                                            </div>
                                        ))}
                                </div>
                            ));
                        }
                        
                        return <p>No hay características adicionales disponibles para esta publicación.</p>;
                    })()}
                </div>
            </Box>
        </Modal>
    );
};

export default ModalCharacteristics;
